import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "06f6f6be-b24b-4c3a-b1e1-a82a8238dd71",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/01/23/task/task-2-answer-a.svg` },
  },
  {
    id: "99a982e1-f500-4ec9-8ec7-77885112f882",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/01/23/task/task-2-answer-b.svg` },
  },
  {
    id: "d908d6da-9d57-4c3e-9efe-ebc7c7d0c9b3",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/01/23/task/task-2-answer-c.svg` },
  },
  {
    id: "48b41915-05ea-4e66-a6de-438d03d984d9",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/01/23/task/task-2-answer-d.svg` },
  },
];

export const task: Task = {
  id: "e4722346-951b-4ef7-b710-fe047185f5e0",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
    imageHeight: 80,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["d908d6da-9d57-4c3e-9efe-ebc7c7d0c9b3"],
};
